import { Box, SxProps, Theme, useTheme } from '@mui/material';
import * as React from 'react';

import { LabelWithError } from './LabelWithError';

interface ILabeledFieldProps {
  label: string;
  value: React.ReactNode;
  error?: boolean;
  errorTooltip?: string;
  valueSx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
}

export const LabeledField: React.FC<ILabeledFieldProps> = ({
  label,
  value,
  error,
  errorTooltip,
  valueSx,
  containerSx,
}) => {
  const theme = useTheme();

  return (
    <Box sx={containerSx}>
      <LabelWithError error={error} errorTooltip={errorTooltip}>
        {label}
      </LabelWithError>
      <Box
        sx={{
          color: error ? theme.sass.errorRed : theme.sass.ebony,
          ...valueSx,
        }}
      >
        {value}
      </Box>
    </Box>
  );
};
